export function cbChunkContentQuery(item, data) {
    return data.push(item);
}
